export enum PlatformTypes {
  DESKTOP = 'DESKTOP',
  MOBILE_WEB = 'MOBILE-WEB',
  MOBILE_APP = 'MOBILE-APP'
}
